









import Vue from 'vue'

export default Vue.extend({
  name: 'Card',
  props: {
    title :  {
      type: String,
      required: true
    }
  },
  components: {
  }
})
